import React, { useEffect, useState } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Select from 'react-select';
import axios from "axios";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import ContractReport from "./componets/ContractReport";
import InvoiceReport from "./componets/InvoiceReport";
import ReciptReport from "./componets/ReciptReport";
import { getTrans as t } from "../../Localization/translations";
import TrialBalance from "../Accounting/TrialBalance";
import AccountingEnteries from "./componets/AccountingEnteries";
import AssetRegister from "./componets/AssetRegister";
import TaxReport from "./componets/TaxReport/TaxReport";
import { useLocation } from "react-router-dom";
import InventoryReport from "./componets/InventoryReport";
import AuditLogReport from "./componets/AuditLogReport";
import BalanceSheet from "./componets/BalanceSheet";
import ContractBalances from "./componets/ContractBalances";
import ContractsIncome from "./componets/ContractsIncome";
import IncomeStatement from "./componets/IncomeStatement";
import AllExpenseReport from "./componets/expensesReport";
import ManualAccountingReport from "./componets/manualaccountingReport";
import Transaction from "../Accounting/Transaction";
import DetailBalanceSheet from "./componets/DetailBalanceSheet";
import DetailIncomeStatement from "./componets/DetailIncomeStatement";




function Reports() {
  const [report, setReport] = useState("contracts");
  const [contracts, setContracts] = useState(false);
  const [trialbalance, setTrailbalance] = useState(false);
  const [accountenteries, setAccountEnteries] = useState(false);
  const [assets, setAssets] = useState(false);
  const [invoices, setInvoices] = useState(false);
  const [recipts, setRecipts] = useState(false);
  const [expenses, setExpenses] = useState(false);
  const [manualaccounting, setManualAccounting] = useState(false);


  const [taxreport, setTaxreport] = useState(false)
  const [auditlog, setAuditlog] = useState(false)
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [items, setItems] = useState([]);
  const { state } = useLocation()
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

  const [selectedAccountCode, setSelectedAccountCode] = useState(null);
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handelChange2 = (value) => {
    setSelectedValue2(value);
  };

  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };

  const handleClear = () => {
    setSelectedValue2("");
    setSelectedValue("");
  };
  const handelOnChange = (e) => {
    const value = e.target.value;

    setReport(value);

    // 🔥 CLEAR ACCOUNT FILTER when manually navigating
    if (value === "accounting") {
      setSelectedAccountCode(null);
      setViewAccounting("accountentries");
    }
  };
  const handleContractOnChange = (e) => {
    setViewContract(e.target.value);
  };
  const handleSearch = () => {
    if (report === "contracts") {
      let url = API + "helper/search/contract/?";
      if (selectedValue === null) {
        url +=
          "contract=" +
          selectedValue2.contract_number +
          "&&status=Active&&customer=";
      } else if (selectedValue2 === null) {
        url +=
          "customer=" +
          selectedValue.customer_name +
          "&&status=Active&&contract=";
      } else {
        url +=
          "customer=" +
          selectedValue.customer_name +
          "&&status=Active&&contract=" +
          selectedValue2.contract_number;
      }
      axios
        .get(url, { headers: authHeader() })
        .then((response) => setItems(response.data.results))
    } else if (report === "invoices") {
      let url = API + "helper/search/invoice/?";
      if (selectedValue === null) {
        url += "contract=" + selectedValue2.contract_number + "&&customer=";
      } else if (selectedValue2 === null) {
        url += "customer=" + selectedValue.customer_name + "&&contract=";
      } else {
        url +=
          "customer=" +
          selectedValue.customer_name +
          "&&contract=" +
          selectedValue2.contract_number;
      }
      axios
        .get(url, { headers: authHeader() })
        .then((response) => setItems(response.data));
    }
  };

  useEffect(() => {
    report === "contracts" ? setContracts(true) : setContracts(false);
    report === "invoices" ? setInvoices(true) : setInvoices(false);
    report === "recipts" ? setRecipts(true) : setRecipts(false);
    // report === "trialbalance" ? setTrailbalance(true) : setTrailbalance(false);
    // report === "accountentries" ? setAccountEnteries(true) : setAccountEnteries(false);
    report === "accounting" ? setTrailbalance(true) : setTrailbalance(false);
    report === "assets" ? setAssets(true) : setAssets(false);
    report === "taxreport" ? setTaxreport(true) : setTaxreport(false)
    report === "auditlog" ? setAuditlog(true) : setAuditlog(false)
    report === "transaction" ? setTransaction(true) : setTransaction(false);

  }, [report]);

  const [viewcontract, setViewContract] = useState("ActiveContract");
  const [viewInvoice, setviewInvoice] = useState("invoicewithdue");
  const [viewReceipts, setviewReceipts] = useState("unappliedreceipts");
  const [viewinventory, setviewInventory] = useState("inventoryreport");
  const [viewTax, setviewTax] = useState("taxrates");
  const [viewAccounting, setViewAccounting] = useState("trialbalance");

  const [transaction, setTransaction] = useState(false);
  const [viewTransaction, setViewTransaction] = useState("expenses");


  const handleInvoiceOnChange = (e) => {
    setviewInvoice(e.target.value);
  };

  const handleReceiptOnChange = (e) => {
    setviewReceipts(e.target.value);
  };
  const handleInventoryOnChange = (e) => {
    setviewInventory(e.target.value);
  };

  const handleTaxRateOnChange = (e) => {
    setviewTax(e.target.value);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (inputValue !== '') {
        setIsLoading(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${inputValue}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  const handleTransactionOnChange = (e) => {
    setViewTransaction(e.target.value);
  };


  const handleInputChangeData = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputValue, currentPage);
  };

  // useEffect(() => {
  //   if(state !== null){
  //     setReport(state);
  //   }
  // }, [])
  useEffect(() => {
    if (state !== null) {
      setReport(state.report || "contracts"); // Set report from state, default to "contracts"
      if (state.report === "invoices" && state.viewInvoice) {
        setviewInvoice(state.viewInvoice); // Set viewInvoice if report is "invoices"
      }
      else if (state.report === "recipts" && state.viewReceipts) {
        setviewReceipts(state.viewReceipts); // Set viewReceipts if report is "recipts"
      }
      else if (state.report === "assets" && state.viewInventory) {
        setviewInventory(state.viewInventory); // Set viewReceipts if report is "recipts"
      }
      else if (state.report === "contracts" && state.viewContracts) {
        setViewContract(state.viewContracts); // Set viewReceipts if report is "recipts"
      }
    }
  }, [state]);

  useEffect(() => {
    if (state && state.report === "accounting") {
      setReport("accounting");
      setViewAccounting("accountentries");
      setSelectedAccountCode(state.accountCode || null);
    }
  }, [state]);


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid pt-3">
          <div className="row show_contract show_invoice">
            <div className="col-md-12">
              <div className="mb-0">
                <div className="header pb-0">
                  <div className="row">
                    <div className="col-xl-9">
                      <span className="mb-3">
                        <h5>{t("Reports")} </h5>
                      </span>
                    </div>
                  </div>
                  <SlidingPane
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={state1.isPaneOpen}
                    title="Filter By"
                    subtitle=""
                    onRequestClose={() => {
                      // triggered on "<" on left top click or on outside click
                      setState({ isPaneOpen: false });
                    }}
                  >
                    <div className="row py-2">
                      <div className="col-xl-12">
                        <div className="form-group row">
                          <label className="col-lg-12 col-form-label">
                            {t("Customer Name")}
                          </label>
                          <div className="col-lg-12">
                            <Select
                              value={selectedValue}
                              filterOption={false}
                              options={options2}
                              isClearable
                              onInputChange={handelInputChange}
                              getOptionLabel={(options) => options.customer_name}
                              getOptionValue={(options) => options.customer_name}
                              isLoading={isLoading2}
                              placeholder={t("Search for Customer(%for All)")}
                              onMenuScrollToBottom={handleMenuScrollToBottomName}
                              onChange={handelChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-12">
                        <div className="form-group row">
                          <label className="col-lg-12 col-form-label">
                            {t("Contract Number")}
                          </label>
                          <div className="col-lg-12">
                            <Select
                              value={selectedValue2}
                              filterOption={false}
                              options={options}
                              isClearable
                              onInputChange={handleInputChangeData}
                              getOptionLabel={(options) => options.contract_number}
                              getOptionValue={(options) => options.contract_number}
                              isLoading={isLoading}
                              placeholder={t("Search for Contract(%for All)")}
                              onMenuScrollToBottom={handleMenuScrollToBottom}
                              onChange={handelChange2}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-12">
                        <div className="form-group row">
                          <div
                            className="col-lg-12 text-left"
                            style={{ marginTop: "30px" }}
                          >
                            <button
                              type="button"
                              className="clearReport btn bg-gradient-secondary ms-auto mb-0"
                              onClick={handleClear}
                            >
                              {t("Reset")}
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="filterReport add btn btn-primary ms-auto mb-0"
                              onClick={handleSearch}
                            >
                              {t("Apply")}
                            </button>
                            &nbsp;&nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                  </SlidingPane>
                  <div className="card">
                    <div className="card-body">
                      <div className="d-lg-flex col-md-6  row ">
                        <div value={report} className="col-md-6">
                          <span className="mb-0 col-form-label">
                            {t("Select Report")}
                          </span>

                          <select
                            className="form-control mb-0"
                            value={report}
                            onChange={handelOnChange}
                          >
                            <option value="contracts" selected>
                              {t("Contracts")}
                            </option>
                            <option value="invoices">
                              {t("Invoices")}
                            </option>
                            <option value="recipts">
                              {t("Receipts")}
                            </option>
                            <option value="assets">
                              {/* {t("Asset Register")} */}
                              {t("Inventory")}
                            </option>

                            <option value="accounting">
                              {t("Accounting")}
                            </option>

                            {/* <option value="expenses">
                              {t("Expenses")}
                            </option>

                            <option value="manualaccounting">
                              {t("Manual Accounting")}
                            </option> */}

                            <option value="transaction">
                              {t("Transactions")}
                            </option>

                            <option value="taxreport">
                              {t("Tax")}
                            </option>
                            <option value="auditlog">
                              {t("Audit")}
                            </option>
                          </select>
                        </div>
                        {contracts && (
                          <div className="col-xl-5">
                            <span className="mb-0 col-form-label">
                              {t("Select Contract")}
                            </span>

                            <select
                              className="form-control mb-0"
                              value={viewcontract}
                              onChange={handleContractOnChange}
                            >
                              <option value="ActiveContract" selected>
                                {t("Active Contracts")}
                              </option>
                              <option value="contracts">
                                {t("All Contracts")}
                              </option>
                              <option value="ContractsByStatus">
                                {t("Contracts By Status")}
                              </option>
                              <option value="Contractsoriginalterm">
                                {t("Average Term Original (Months)")}
                              </option>
                              <option value="Contractsremainingterm">
                                {t("Average Term Remaining (Months)")}
                              </option>
                            </select>
                          </div>
                        )}
                        {invoices && (
                          <div className="col-xl-4">
                            <span className="mb-0 col-form-label">
                              {t("Select Invocie")}
                            </span>
                            <select
                              className="form-control mb-0"
                              value={viewInvoice}
                              onChange={handleInvoiceOnChange}
                            >
                              <option value="invoice">
                                {t("All Invoices")}
                              </option>
                              <option value="invoicewithdue" selected>
                                {t("Invoices with Due")}
                              </option>
                              <option value="invoiceaging">
                                {t("Delinquency Aging")}
                              </option>
                            </select>
                          </div>
                        )}
                        {recipts && (
                          <div className="col-xl-4">
                            <span className="mb-0 col-form-label">
                              {t("Select Receipts")}
                            </span>
                            <select
                              className="form-control mb-0"
                              value={viewReceipts}
                              onChange={handleReceiptOnChange}
                            >
                              <option value="receipt">
                                {t("All Receipts")}
                              </option>
                              <option value="unappliedreceipts" selected>
                                {/* {t("Unapplied Receipts")} */}
                                {t("Unapplied Payments")}
                              </option>
                            </select>
                          </div>
                        )}
                        {assets && (
                          <div className="col-xl-6">
                            <span className="mb-0 col-form-label">
                              {t("Select Inventory")}
                            </span>
                            <select
                              className="form-control mb-0"
                              value={viewinventory}
                              onChange={handleInventoryOnChange}
                            >
                              <option value="inventoryreport">
                                {t("Inventory Register")}
                              </option>
                              <option value="assetreport" selected>
                                {/* {t("Unapplied Receipts")} */}
                                {t("Asset Concentration By Category ")}
                              </option>
                              <option value="assetbylocationreport" selected>
                                {/* {t("Unapplied Receipts")} */}
                                {t("Asset Concentration By Location")}
                              </option>
                            </select>
                          </div>
                        )}
                        {trialbalance && (
                          <div className="col-xl-5">
                            <span className="mb-0 col-form-label">
                              {t("Select Accounting Report")}
                            </span>

                            <select
                              className="form-control mb-0"
                              value={viewAccounting}
                              onChange={(e) => setViewAccounting(e.target.value)}
                            >
                              <option value="accountentries">
                                {t("Accounting Entries")}
                              </option>
                              <option value="trialbalance">
                                {t("Trial Balance Report")}
                              </option>
                              <option value="balancesheet">
                                {t("Balance Sheet")}
                              </option>
                              <option value="detailbalancesheet">
                                {t("Balance Sheet Detail")}
                              </option>
                              <option value="incomestatement">
                                {t("Income Statement")}
                              </option>
                              <option value="detailincomestatement">
                                {t("Income Statement Detail")}
                              </option>
                              <option value="contractbalances">
                                {t("Balances By Contract")}
                              </option>
                              <option value="contractincome">
                                {t("Income By Contracts")}
                              </option>



                            </select>
                          </div>
                        )},

                        {transaction && (
                          <div className="col-xl-4">
                            <span className="mb-0 col-form-label">
                              {t("Select Transaction Report")}
                            </span>
                            <select
                              className="form-control mb-0"
                              value={viewTransaction}
                              onChange={handleTransactionOnChange}
                            >
                              <option value="expenses">
                                {t("Expenses")}
                              </option>
                              <option value="manualaccounting">
                                {t("Manual Accounting")}
                              </option>
                            </select>
                          </div>
                        )}







                        {taxreport && (
                          <div className="col-xl-4">
                            <span className="mb-0 col-form-label">
                              {t("Select Tax Report")}
                            </span>
                            <select
                              className="form-control mb-0"
                              value={viewTax}
                              onChange={handleTaxRateOnChange}
                            >
                              <option value="taxrates" selected>
                                {t("Tax Rates")}
                              </option>
                              <option value="taxcalculation">
                                {t("Tax Calculation")}
                              </option>
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="body py-2">
          <div className="col-md-12">
            {contracts && (
              <ContractReport id={items} setContract={viewcontract} />
            )}
            {invoices && (
              <InvoiceReport id={items} setInvoiceview={viewInvoice} />
            )}
            {recipts && <ReciptReport setReceiptview={viewReceipts} />}
            {/* {trialbalance && <AccountingEnteries />}
            {accountenteries && <TrialBalance />} */}
            {trialbalance && viewAccounting === "trialbalance" && <AccountingEnteries />}
            {/* {trialbalance && viewAccounting === "accountentries" && <TrialBalance />}
            {trialbalance && viewAccounting === "accountingentries" && (
              <TrialBalance
                initialAccountCode={selectedAccountCode}
              />
            )} */}

            {trialbalance && viewAccounting === "accountentries" && (
              <TrialBalance initialAccountCode={selectedAccountCode} />
            )}

            {trialbalance && viewAccounting === "balancesheet" && <BalanceSheet />}
            {trialbalance && viewAccounting === "contractbalances" && <ContractBalances />}
            {trialbalance && viewAccounting === "contractincome" && <ContractsIncome />}
            {trialbalance && viewAccounting === "incomestatement" && <IncomeStatement />}
            {trialbalance && viewAccounting === "detailbalancesheet" && <DetailBalanceSheet />}
            {trialbalance && viewAccounting === "detailincomestatement" && <DetailIncomeStatement />}

            {transaction && viewTransaction === "expenses" && <AllExpenseReport />}
            {transaction && viewTransaction === "manualaccounting" && <ManualAccountingReport />}



            {/* {assets && <AssetRegister />} */}
            {assets && <InventoryReport setInventoryview={viewinventory} />}
            {taxreport && <TaxReport setTax={viewTax} />}
            {auditlog && <AuditLogReport />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;
